module.exports = __webpack_public_path__ + "img/TheOfficeTeam.f28ef9b4.webp";